import { type UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getUser } from "@/features/panel/api/get-user";
import type { FoodangoUser } from "@/types/foodango-user";

export const useGetUser = (
  options?: Omit<
    UseQueryOptions<
      FoodangoUser | null,
      unknown,
      FoodangoUser | null,
      string[]
    >,
    "queryFn" | "queryKey"
  >
) => {
  return useQuery({
    queryKey: ["user"],
    queryFn: async () => await getUser(),
    ...options,
  });
};
